<!--常见的左边某个树右边是内容的结构
-->
<template>
	<div class="lefttreeBody" ref="box">
		<slot></slot>
		<div ref="left" class="tree" v-show="showLeft">
			<img class="showTreeIcon" v-if='!showTree' :src="$store.resourcesStore.getters.getResourcesByName('arrow/arrow_right.png')" @click="showTree = !showTree">
			<img class="showTreeIcon" v-else :src="$store.resourcesStore.getters.getResourcesByName('arrow/arrow_left.png')" @click="showTree = !showTree">
			<div class="tree-part" v-show="showTree">
				<div class="custom-scrollbar" >
					<slot name="tree"></slot>
				</div>
			</div>
		</div>
		<div ref="right" class="body" :style="$store.resourcesStore.getters.getBackgroudImageStyle('background/rigth_background.png'),getBodyWidth">
			<slot name="body"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			showLeft:{
				type:Boolean,
				default:true
			}
		},
		data() {
			return {
				showTree: true,
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getColorById() {
				return id => {
					return this.$store.resourcesStore.getters.getColorById(id)
				}
			},
			getBodyWidth() {
				if (this.showTree) {
					return {
						width: "calc(100% - 2.2rem)"
					}
				}
				return {
					width: "calc(100% - 0.18rem)"
				}
			}
		},
		watch: {
			showTree(nv, ov) {
				//通知父组件，可能要重新渲染body内容
				this.$emit("showTree", nv)
			}
		},
		methods: {

		}
	}
</script>

<style scoped>
	.lefttreeBody {
		height: 100%;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.tree {
		height: 100%;
		background-size: 100% 100%;
		overflow: hidden;
		width: auto;
	}

	.tree-part {
		min-width: 2.2rem;
		max-width: 2.2rem;
		width: 2.2rem;
		height: calc(100% - 28px);
	}

	.tree-part>div {
		width: 2.1rem;
		height: calc(100% - .2rem);
		position: relative;
	}

	.tree-part>div>div {
		position: absolute;
	}

	.showTreeIcon {
		width: .18rem;
		height: .18rem;
		padding: .2rem .12rem 0 .1rem;
		display: inline-block;
		cursor: pointer;
		animation: left-jump 0.5s infinite alternate;
	}
	.showTreeIcon:hover{
		animation: stop;
	}
	@keyframes left-jump {
	  to {
		 transform: translate(5px); 
	  }
	}
	@keyframes stop {
	to {
		/* transform: translate(5px); */
	}
	}
	.body {
		height: 100%;
		/* margin-left: 20px; */
		overflow: hidden;
	}
	.body>div{
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
</style>
